import { WidgetTheme } from '../../WidgetTheme'
import { WidgetProps } from '../../widget.types'
import { useThemeConfig } from '../../hooks/useThemeConfig'
import { WidgetBox, WidgetContainer } from '../../widget.styles'
import { InfoBox, SuccessBox } from '../..'
import { IlustrationBox } from './IlustrationBox'

import { useResumeDistributionConfig } from './hooks/useResumeDistributionConfig'
import { useResumeDistributionActions } from './hooks/useResumeDistributionActions'

export const ResumeDistribution = ({ service }: WidgetProps) => {
  const theme = useThemeConfig({ service })
  const { text, status, recruitersCount } = useResumeDistributionConfig(service)
  const { handleInitialClick, handleInProgressClick, handleCompletedClick } =
    useResumeDistributionActions()

  const isCompleted = status === 'completed'

  const handleClick = () => {
    if (isCompleted) return handleCompletedClick()
    if (status === 'progress') return handleInProgressClick()
    return handleInitialClick()
  }

  return (
    <WidgetTheme tipOrder={2} theme={theme[status]}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox text={text} isCompleted={isCompleted} handleClick={handleClick} />
        </WidgetBox>
        <WidgetBox>
          {isCompleted ? (
            <SuccessBox />
          ) : (
            <IlustrationBox
              status={status}
              recruitersCount={recruitersCount}
              recruitersText={text.recruiters}
            />
          )}
        </WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
